import { render, staticRenderFns } from "./AnchorBar.vue?vue&type=template&id=54d8166e&"
import script from "./AnchorBar.vue?vue&type=script&lang=js&"
export * from "./AnchorBar.vue?vue&type=script&lang=js&"
import style0 from "./AnchorBar.vue?vue&type=style&index=0&id=54d8166e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports